import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function CollapsedColumn({ status, expand }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.collapsedColumn} onClick={expand}>
      <div className={styles.heading}>
        <ToggleArrow className={styles.icon} styles={{ fill: status.color }} />
        <div className={styles.title} style={{ color: status.color }}>
          <h3>{t(`taskStatuses.${status.label}`, status.label)}</h3>
          {typeof status.percentComplete !== "undefined" &&
            status.percentComplete !== null && (
              <p className={styles.progress}>{status.percentComplete}%</p>
            )}
        </div>
      </div>
      <div
        className={styles.progressBar}
        style={{
          backgroundColor: status.color,
          height: `${status.percentComplete}%`,
        }}
      />
    </div>
  );
}

export { CollapsedColumn };
